import { clientFetch } from '@biw/client-fetch';
import Errors from 'dux/errors/errors';
import { addError } from 'dux/errors';
import { Dispatch } from 'app/types/redux';

const noEnvData = {};

/**
 * Determines the environment based on the window location
 * @param {*} windowLocation
 */
export function getEnv( windowLocation = window.location ) {
    const envs = [ 'dev.', 'ci.', 'qa.', 'qa2.', 'pprd.' ];
    if ( windowLocation.port ) {
        return 'dev';
    } else {
        return windowLocation.hostname.split( '.' ).find( (chunk) => {
            return envs.indexOf( chunk + '.' ) >= 0;
        } ) || 'prod';
    }
}

/******************
 * Initial state
 */
const initialState = { loaded: false };

/******************
 * Non-async action types
 */
const ENV = 'env';
const ENV_SET_DATA = 'ENV_SET_DATA';

/******************
 * Reducer
 */
export default function envReducer( state = initialState, action: any ) {
    switch ( action.type ) {
        case ENV_SET_DATA:
            return {
                ...state,
                ...action.newValue,
                loaded: true,
            };
        default:
            return state;
    }
}

/******************
 * Action creators
 */
export function setEnvData( newValue: any ) {
    return {
        type: ENV_SET_DATA,
        newValue,
    };
}

export function fetchEnvData() {
    return (dispatch: Dispatch) => {

        return clientFetch( { url: '/api/v1.0/env', type: ENV, catchError: true } )
            .then( ( env: any ) => {
                dispatch( setEnvData( env ) );
            } )
            .catch( ( error: Error ) => {
                dispatch( addError( error, Errors.ERROR_CLIENT_FETCHENVDATA ) );
                dispatch( setEnvData( noEnvData ) );
            } );
    };
}
